export default "https://cdn-static.gokick.com/assets/2b3e6896c425e2cf7d1a83db5abe7919e5484d77/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";